import axios from 'axios';
import { config } from '../config';

const API_URL = config.BACKEND_URL;

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true
});

export const extractFromImages = async (files, onProgress) => {
  const formData = new FormData();
  for (const file of files) {
    formData.append('images', file);
  }

  const response = await api.post('/api/ai-vision/extract-card', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 120000,
    onUploadProgress: onProgress
  });
  return response.data;
};

export const getBatches = async () => {
  const response = await api.get('/api/ai-vision/batches');
  return response.data;
};

export const deleteBatch = async (id) => {
  const response = await api.delete(`/api/ai-vision/batches/${id}`);
  return response.data;
};

export const getVisionPrompt = async () => {
  const response = await api.get('/api/ai-vision/vision-prompt');
  return response.data;
};

export const updateVisionPrompt = async (promptText) => {
  const response = await api.put('/api/ai-vision/vision-prompt', {
    prompt_text: promptText
  });
  return response.data;
};

const aiVisionService = {
  extractFromImages,
  getBatches,
  deleteBatch,
  getVisionPrompt,
  updateVisionPrompt
};

export default aiVisionService;
